import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Badkern „Auswahl & Verfügbarkeit“ (24.09.2026).
 * Horizon morpht beim Variantenwechsel nur den Variant-Picker; jeder andere
 * Baustein aktualisiert sich selbst aus dem productSelect-Event (Muster:
 * product-inventory.js). Hier: Klassen (Lagerstatus-Farbe) + Inhalt übernehmen.
 */
class AuswahlVerfuegbarkeit extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        const neu = html.querySelector('auswahl-verfuegbarkeit');
        if (!neu) return;
        this.className = neu.className;
        morph(this, neu, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[auswahl-verfuegbarkeit] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('auswahl-verfuegbarkeit')) {
  customElements.define('auswahl-verfuegbarkeit', AuswahlVerfuegbarkeit);
}
